module.exports = __webpack_public_path__ + "assets/img/scenePic11_app.58e0b808.png";